import { HeaderWithAlert, PopUpInformative } from 'components';
import { Images } from '../../assets/images/images.index';

import { IDetailStep } from 'models';
import { PaymentMethodForm } from 'pages/Settings/pages/Add-subscription/componentes/PaymentMethodForm';
import { GetUserByTokenPaymentMethodLinkReturn } from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserByTokenPaymentMethodLink } from 'shared/services/payment-method-link';

export const PaymentMethodLink = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [userWihtoutAuth, setUserWihtoutAuth] =
    useState<GetUserByTokenPaymentMethodLinkReturn>({
      customer: '',
      customerName: '',
      expires: 0,
      token: '',
      url: '',
    });
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [showAlertError, setShowAlertError] = useState<string>('');
  const [popupState, setPopupState] = useState({
    isOpen: false,
    type: 'success',
    msg: '',
  });

  const handleClosePopUp = () => {
    setPopupState({ ...popupState, isOpen: false });
    navigate('/');
  };

  const STEPS: IDetailStep[] = [
    {
      description: 'Login',
      state: 'active',
      link: '/login',
      permissionToNavigate: true,
    },
  ];

  useEffect(() => {
    const getUserByMethodPaymentLink = async () => {
      setLoading(true);
      setError(false);
      try {
        if (!token) throw new Error('token is missing');
        const user = await getUserByTokenPaymentMethodLink(token);
        setUserWihtoutAuth(user);
      } catch (err) {
        setError(true);
        if (err instanceof Error) {
          setShowAlertError(err.message);
        } else {
          setShowAlertError('Error al validar el link');
        }
      } finally {
        setLoading(false);
      }
    };

    getUserByMethodPaymentLink();
  }, [token]);

  const handleError = (value: string | null) => {
    setShowAlertError(value ?? 'Error creando el método de pago');
  };

  if (loading) return <div>Cargando link...</div>;
  if (error) return <div>Hubo un error al obtener el link</div>;

  return (
    <>
      {showAlertError && (
        <PopUpInformative
          title={showAlertError}
          type="error"
          closePopUp={() => setShowAlertError('')}
        ></PopUpInformative>
      )}
      {popupState.isOpen && (
        <PopUpInformative
          title={popupState.msg}
          type="successful"
          closePopUp={handleClosePopUp}
        />
      )}
      <HeaderWithAlert
        steps={STEPS}
        onClick={() => navigate('/settings')}
      ></HeaderWithAlert>
      {userWihtoutAuth.customerName && (
        <div className="add-subscription__header">
          <h6>Hola {userWihtoutAuth.customerName}</h6>
        </div>
      )}
      <div className="container__payment__link container__generic">
        <div className="content__payment payment__padding">
          <a
            className="stripe__badge"
            href="https://stripe.com/docs/security"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Images.stripeBadge} alt="Logo pago seguro" />
          </a>
        </div>

        <main
          className="add-subscription__container container__generic"
          role="main"
          aria-label="Agregar suscripción"
        >
          <PaymentMethodForm
            userAuthId={userWihtoutAuth.customer}
            setPopupState={setPopupState}
            isPaymentMethodLink={true}
            handleError={handleError}
          />
        </main>
      </div>
    </>
  );
};
